module.exports = __webpack_public_path__ + "static/GetPasses-913af17d159e3f5e8983c671b17b2dc0.svg";